import { toastr } from 'react-redux-toastr'
import branditRails from '../api/brandit_rails'
import { SESSION_ROUTES } from '../Constants'
import history from '../history'
import { saveUrlToLocalStorage } from '../utility/Utils'
import { CURRENT_ACTIONS } from './types'
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'

export const redirectToLogin = error => {
  const path = window.location.pathname.toString()
  const SessionRoutes = SESSION_ROUTES
  if (SessionRoutes.every(route => !path.includes(route))) {
    saveUrlToLocalStorage()
    history.push('/login')
    history.go(0)
  }
}

/**
 * Fetches agencies and dispatches them to the store.
 *
 * @function fetchAgencies
 * @returns {Promise<import('../reducers/agenciesReducer').Agencies | undefined>} The agencies data if successful, or undefined if the request fails.
 */
export const fetchAgencies = () => async dispatch => {
  /**
   * @typedef {Object} AgenciesResponse
   * @property {import('../reducers/agenciesReducer').Agencies} data - The agencies data returned by the API.
   * @property {number} status - The HTTP status code of the response.
   */

  /** @type {AgenciesResponse} */
  const { data, status } = await branditRails.get('/admin/organization/agencies')

  const agencies = Array.isArray(data) ? data : Array.isArray(data?.agencies) ? data.agencies : []

  if (status === 200) {
    dispatch({ type: 'SET_AGENCIES', payload: agencies })

    return agencies
  }
}

// fetches agency based on ID stored in auth token
export const fetchCurrentAgency = () => async dispatch => {
  try {
    const response = await branditRails.get('/current_agency')
    if (response.data && response.status === 200) {
      dispatch({ type: CURRENT_ACTIONS.SET_AGENCY, payload: response.data })
    }
  } catch (error) {
    if (error?.response?.status === 401) {
      if (window.location.pathname !== '/login') {
        toastr.error(errorMessage ? errorMessage : 'Session expired. Please login again.')
      }
    }
    throw error
  }
}

/**
 *
 * @function initializeAgency
 * @returns {{type: string}} The action object with a `type` property set to `'INITIALIZE_AGENCY'`.
 */
export const initializeAgency = () => ({
  type: 'INITIALIZE_AGENCY'
})
